const api = {
  GET_PROMO_LIST: '/index.php?r=api/v1/promo/promo-merchant/index',
  GET_MID_LIST_PROMO: '/index.php?r=api/v1/promo/list-mid-promo/index',
  GET_DETAIL_PROMO: '/index.php?r=api/v1/promo/promo-merchant/detail',
  GET_LIST_MERCHANT: '/index.php?r=api/v1/promo/list-merchant/index',
  DOWNLOAD_TEMPLATE: 'index.php?r=api/v1/promo/list-merchant/download',
  DOWNLOAD_MERCHANT_PROMO: 'index.php?r=api/v1/promo/list-merchant/download-merchant',
  DOWNLOAD_FAILED_MERCHANT_PROMO: 'index.php?r=api/v1/promo/list-merchant/download-merchant-failed',
  BULK_UPLOAD: 'index.php?r=api/v1/promo/promo-merchant/bulk-upload',
  BULK_DELETE: 'index.php?r=api/v1/promo/promo-merchant/delete-file',
};

export default api;